/* Public-only route config. Defines the routes available outside of /admin/*. The single-bundle build always includes both this and config-admin; admin routes are excluded from the initial download via React.lazy in app-router.tsx. */
/* eslint-disable react-refresh/only-export-components -- route config module, not a component file */
import type { IRouteProps } from '@/app/router-types'

import { AccountMembersListView } from './account/account-members-list-view'
import { BulkImportHistoryView } from './import/bulk-import-history'
import { BulkImportRunView } from './import/bulk-import-run'
import { UserDetailsView } from './user/user-details'
import { UserPublicCreateView } from './user/user-public-create'

export const publicRoutes: IRouteProps[] = [
  {
    id: 'ACCOUNT_MEMBERS',
    name: 'ACCOUNT_MEMBERS',
    path: '/account/:accountId/users',
    view: <AccountMembersListView />,
    documentTitle: 'ACCOUNT_MEMBERS',
    options: {},
  },
  {
    // An account's past imports, so a run can be reached again after the tab that
    // started it is closed. Public, not staff-only: an account admin reaches it from the
    // nav, staff from the staff account page, and the backend decides who may read it.
    id: 'BULK_IMPORT_HISTORY',
    name: 'BULK_IMPORT_HISTORY',
    path: '/account/:accountId/imports',
    view: <BulkImportHistoryView />,
    documentTitle: 'BULK_IMPORT_HISTORY',
    options: {},
  },
  {
    // Account-scoped so Cancel and the breadcrumb have an account to return to. The
    // backend authorises a run by its own id, so the account here is context, not the
    // permission check.
    id: 'BULK_IMPORT_RUN',
    name: 'BULK_IMPORT_RUN',
    path: '/account/:accountId/imports/:runId',
    view: <BulkImportRunView />,
    documentTitle: 'BULK_IMPORT_RUN',
    options: {},
  },
  {
    id: 'USER_DETAILS',
    name: 'USER_DETAILS',
    path: '/user/details/:id',
    view: <UserDetailsView />,
    documentTitle: 'USER_DETAILS',
    options: {},
  },
  {
    id: 'USER_CREATE',
    name: 'USER_CREATE',
    path: '/user/create',
    view: <UserPublicCreateView />,
    documentTitle: 'CREATE_USER',
    options: {},
  },
]

export const RouterConfiguration = (): IRouteProps[] => publicRoutes
